// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Antd = require("antd");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var StripeUX__Shared$SmartcutsMacros = require("./StripeUX__Shared.bs.js");

var button = CssJs.selector(".manageSubscription", [
      CssJs.color({
            NAME: "hex",
            VAL: "1890ff"
          }),
      CssJs.position("absolute"),
      CssJs.right({
            NAME: "px",
            VAL: 24
          }),
      CssJs.top({
            NAME: "px",
            VAL: 24
          }),
      CssJs.padding("zero")
    ]);

var Style = {
  button: button
};

function StripeUX__ManageSubscriptionButton(Props) {
  var type_ = Props.type_;
  var stripeCustomerId = Props.stripeCustomerId;
  var router = Props.router;
  var children = Props.children;
  if (type_ === "button") {
    return React.createElement(Antd.Button, {
                size: "large",
                type: "primary",
                onClick: (function (_event) {
                    return StripeUX__Shared$SmartcutsMacros.manageSubscription(stripeCustomerId, router);
                  }),
                children: children
              });
  }
  return React.createElement("a", {
              className: "manageSubscription",
              onClick: (function (_event) {
                  return StripeUX__Shared$SmartcutsMacros.manageSubscription(stripeCustomerId, router);
                })
            }, children);
}

var make = StripeUX__ManageSubscriptionButton;

exports.Style = Style;
exports.make = make;
/* button Not a pure module */
